import React, { Component } from "react"
import { Link } from 'gatsby';
// import AnchorLink from 'react-anchor-link-smooth-scroll';

import Layout from "../components/layout"
import SEO from "../components/seo"

import SimpleModalVideo from '../components/utilities/SimpleModalVideo';

import "./casestudyamdocsmicrosoft.scss"

import imgQuote from "../images/quotation_mark.webp"

class LocalVideo extends Component {
  constructor(props) {
      super(props);
      this.modalRef = React.createRef();
      this.openModal = this.openModal.bind(this);
  };
  openModal() {
      this.modalRef.current.handleOpen();
  };
    render() {
        return (
            <>
                <img
                    src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-microsoft-creative-sample-video-1.webp"
                    className="results-image img-fluid"
                    alt="Amdocs Microsoft Video 1"
                    width="775px"
                    style={{ maxWidth: '100%' }}
                    onClick={() => this.openModal()} id="playVideo"
                />
                <SimpleModalVideo videoSRC='l8XvurqzsJY' innerRef={this.modalRef} />
            </>
        );
    }
}

class LocalVideoTwo extends Component {
  constructor(props) {
      super(props);
      this.modalRef = React.createRef();
      this.openModal = this.openModal.bind(this);
  };
  openModal() {
      this.modalRef.current.handleOpen();
  };
    render() {
        return (
            <>
                <img
                    src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-microsoft-creative-sample-video-2.webp"
                    className="results-image img-fluid"
                    alt="Amdocs Microsoft Video 2"
                    width="775px"
                    style={{ maxWidth: '100%' }}
                    onClick={() => this.openModal()} id="playVideoTwo"
                />
                <SimpleModalVideo videoSRC='NdfwD_duwuA' innerRef={this.modalRef} />
            </>
        );
    }
}


export default ({ pageContext }) => (
    <Layout>
        <SEO
            title={pageContext.yoast.title}
            description={pageContext.yoast.metadesc}
            ogimg={pageContext.yoast.opengraph_image}
            link={pageContext.link}
        />
        <div className="case-study-amdocs-wrapper">
            <div className="container-fluid">
                <div className="row">
                    <div
                        className="header-container"
                        style={{
                            backgroundImage: `url(${pageContext.acf.header_image.csOneHedImaLocalFile.childImageSharp.fluid.src})`,
                        }}
                    >
                        <img src={imgQuote} alt="" />
                        <h2>{pageContext.acf.header_text}</h2>
                    </div>
                </div>
            </div>
            <div className="container detail-wrapper">
                <div className="row">
                    <div className="col-md-8">
                        <img
                            src={
                                pageContext.acf.client_logo.csOneCliLogLocalFile.childImageSharp
                                    .fluid.src
                            }
                            className="client-logo"
                            width={pageContext.acf.client_logo.media_details.width / 1.25}
                            height={pageContext.acf.client_logo.media_details.height / 1.25}
                            alt={pageContext.yoast.opengraph_title}
                        />
                    </div>
                    <div className="col-md-4">
                        <a href="https://apiold.meritmile.com/wp-content/uploads/2025/11/merit-mile-amdoc-microsoft-case-study-2025.pdf" className="btn downloadBtn" target="_blank" rel="nofollow noopener noreferrer" style={{ marginTop: '4em'}}>Download the Report Now</a>
                    </div>
                    <div className="col-12">
                        <div className="bar"></div>
                    </div>
                    <div className="col-12">
                        <div
                            className="first-paragraph"
                            dangerouslySetInnerHTML={{
                                __html: pageContext.acf.first_paragraph,
                            }}
                        />
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 ">
                        <h3>Challenge</h3>
                        <p>Amdocs and Microsoft shared a common business objective: penetrate and establish new relationships with high-value telecom accounts. Their goal was to reach decision-maker roles, Director and above, at major CSPs across key global markets, including North America, Europe, Africa, Asia, and Central and South America. Having previous ABM campaign success with Merit Mile, including <a href="/case-studies/finastra-microsoft/"><strong>Finastra</strong></a>, <a href="/case-studies/teladoc-health-microsoft/"><strong>Teladoc Health</strong></a>, and <a href="/case-studies/capgemini/"><strong>Capgemini</strong></a>, Microsoft introduced Amdocs to Merit Mile to achieve these goals.</p>
                        <p>With competitive pressure mounting and critical industry events approaching, Amdocs and Microsoft needed more than a traditional campaign. They required a custom ABM program that could cut through market noise, speak directly to the needs of targeted telecom audiences, and scale effectively across geographies.</p>
                    </div>
                </div>
            </div>
            <div className="fullWidthGrayCTA">
              <div className="container">
                <div className="row mt-4 margin-b">
                    <div className="col-12">
                        <h3>Solution</h3>
                        <p>Merit Mile began aligning Amdocs and Microsoft's campaign objectives to their global marketing scorecard and sales goals. After developing the <strong>Ideal Customer Profile (ICP) and a Target Account List (TAL)</strong>, the Merit Mile team crafted an ABM strategy built on market awareness and a two-touch engagement model. This structure ensured that prospects would not be converted to leads until they engaged with at least two campaign assets—signaling a higher level of interest and intent. This approach elevated lead quality and provided Amdocs sellers with valuable engagement data for follow-up.</p>
                        <p>Merit Mile developed a comprehensive set of campaign marketing offers including the "Telco Tipping Point" a custom eBook, sizzle reels, and demo videos. These were complemented by S&amp;P Global 451 Research and OMDIA reports to lend third-party validation and market authority. While the campaign was in-market, <strong>always-on display advertising</strong> was run to create awareness about the solution and two flagship customer events—Mobile World Congress and DTW25-Ignite. Creative elements and media placements were optimized in real time based on performance, ensuring continued engagement throughout the campaign’s lifecycle.</p>
                        <p>In addition to generating leads, Merit Mile supported Amdocs' internal sales activation with <strong>enablement materials</strong> including lead nurture emails, tele-guides, and campaign playbooks. These provided sellers with insights, content, and structure needed to advance conversations with engaged accounts.</p>
                    </div>
                </div>
              </div>
              <div className="text-center margin-b">
                  <img
                      src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-microsoft-creative-sample-top.webp"
                      className="results-image img-fluid"
                      alt="Amdocs Microsoft Samples Top"
                      width="1600px"
                      style={{ marginBottom: '0em' }}
                  />
              </div>
              <div className="text-center row g-0 margin-b" style={{ maxWidth: '1600px', margin: '0 auto' }}>
                  <div className="col-12 col-md-6 text-right p-0">
                    <LocalVideo />
                  </div>
                  <div className="col-12 col-md-6 text-left p-0">
                    <LocalVideoTwo />
                  </div>
              </div>
              <div className="text-center margin-b">
                  <img
                      src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-microsoft-creative-sample-bottom.webp"
                      className="results-image img-fluid"
                      alt="Amdocs Microsoft Samples Bottom"
                      width="1600px"
                      style={{ marginBottom: '0em' }}
                  />
              </div>
            </div>
            <div className="container detail-wrapper">
                <div className="row mt-4 margin-b">
                    <div className="col-12">
                        <h3>Results</h3>
                        <p>The campaign exceeded expectations across every KPI, delivering high-value ABM leads and meaningful engagement with telecom decision-makers across multiple global regions. Weekly lead quality control ensured accuracy and alignment with Amdocs' TAL and real-time campaign dashboards tracked performance, ROI, and lead quality.</p>
                        <p>In total, the campaign generated <strong>550 qualified, double-touch leads</strong> from 34 unique telecom and CSP companies. More than 705,000 impressions were achieved across display and video advertising, and the campaign delivered an outstanding click-through rate (CTR) of 1.12%)—nearly <strong>10x the industry average</strong> for similar programs.</p>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">
                      <p>As the campaign progressed, Merit Mile optimized for even greater performance including creative and messaging refreshes, media placements, and shorting video lengths to maximize the Video Completion Rate (VCR).</p>
                      <h4 className="mt-4"><strong>Audience Penetration</strong></h4>
                      <p>The results underscore ABM's effectiveness at reaching mid- to senior-level decision-makers, those most likely to influence buying decisions. Based on these results, future phases of the campaign are expected to prioritize deeper engagement with VP and C-level executives.</p>
                    </div>
                    <div className="col-12 col-md-6">
                      <img
                            src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-case-study-total-audience-performance.webp"
                            className="results-image img-fluid"
                            alt="Amdocs Microsoft Total Audience Performance"
                            width="501px"
                            style={{ marginBottom: '2em' }}
                        />
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 text-center">
                        <img
                            src="https://apiold.meritmile.com/wp-content/uploads/2025/11/amdocs-abm-campaign-display-ad-results.webp"
                            className="results-image img-fluid"
                            alt="Amdocs Microsoft ABM Campaign Display Ad Results"
                            width="1200px"
                            style={{ marginBottom: '2em' }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                      <h3>Merit Mile Account Based Marketing Services</h3>
                    </div>
                </div>
                <div className="row margin-b">
                    <div className="col-12 col-md-6">                        
                        <ul>
                            <li>Marketing and campaign strategy</li>
                            <li>Media buy and vendor management</li>
                            <li>Campaign execution and optimization</li>
                        </ul>
                    </div>
                    <div className="col-12 col-md-6">                        
                        <ul>
                            <li>Campaign reporting and analytics</li>
                            <li>Content development and creative design</li>
                            <li>Video production</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="fullWidthGrayCTA">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h5>Contact <a href="mailto:ABM@MeritMile.com?subject=Amdocs%20Microsoft%20Case%20Study%20Inquiry"><b style={{ color: "black" }}>ABM@MeritMile.com</b></a> or visit <a href="https://www.meritmile.com/abm/"><b style={{ color: "black" }}>www.meritmile.com/abm/</b></a> to learn more about proven, predictable, and measurable ABM.</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div className="yourteam-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3>Your Merit Mile Team</h3>
                        </div>
                    </div>
                    <div className="row margin-b">
                        <div className="col-12">
                            <div className="team-cards">
                                <div className="team-card">
                                    <img
                                        src="https://www.meritmile.com/uploads/2022/08/sl-thumb.jpg"
                                        alt="Scott Lindars"
                                        className="img-fluid"
                                    />
                                    <h4>Scott Lindars</h4>
                                    <p>
                                        Director<br />
                                        Marketing +<br />
                                        Business Strategy
                                    </p>
                                </div>
                                <div className="team-card">
                                    <img
                                        src="https://www.meritmile.com/uploads/2022/08/sd-thumb.jpg"
                                        alt="Saul Darville"
                                        className="img-fluid"
                                    />
                                    <h4>Saul Darville</h4>
                                    <p>
                                        Executive<br />
                                        Creative<br />
                                        Director
                                    </p>
                                </div>
                                <div className="team-card">
                                    <img
                                        src="https://www.meritmile.com/uploads/2022/08/mc-thumb.jpg"
                                        alt="Mitch Curry"
                                        className="img-fluid"
                                    />
                                    <h4>Mitch Curry</h4>
                                    <p>
                                        Project<br />
                                        Manager<br />
                                        &nbsp;
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fullWidthImageWrapper">
                <img
                    src="https://www.meritmile.com/uploads/2021/09/mm-divider.jpg"
                    alt="Merit Mile Icon Divider"
                    className="img-fluid"
                />
            </div>
            <div className="about-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <h2>About Merit Mile</h2>
                        </div>
                    </div>
                    <div className="row margin-b">
                        <div className="col-md-6">
                            <p>Established in 2007 in Boca Raton, FL, Merit Mile is a marketing services provider focused on helping companies and corporate marketing departments build brands, drive sales revenue, and garner publicity in their respective industries. Our unique differentiator at Merit Mile is our ability to 100% own the message, the publicity, and the demand generation aspects of the corporate marketing function. Clients hire us and rehire us for our ability to refine their messaging/value proposition, develop top and mid-funnel leads, and get the type of editorial publicity that differentiates them from their competitors. From branding to PR to demand generation, Merit Mile is the high-octane fuel that invigorates corporate growth engines. To learn more, please email us at Hello@MeritMile.com, call us at 1-561-362-888, or visit us at www.MeritMile.com. </p>
                        </div>
                        <div className="col-md-6"><img className="img-fluid" src="https://www.meritmile.com/uploads/2021/06/mm-headquarter.webp" alt="Merit Mile Headquarter in Boca Raton, FL" /></div>
                    </div>
                </div>
            </div>
            <div className="container quote-wrapper">
                <div className="row">
                    <div className="col-12">
                        <p>
                            For more insights and to connect<br />
                            with Merit Mile <a href="mailto:Hello@MeritMile.com?subject=Teldoc%20Health%20Microsoft%20Case%20Study%20Inquiry"><b style={{ color: "black" }}>email us here</b>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
)
